import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/requests/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const { requestResources } = useSelector((state) => state.requests);
  const [requestResourcesOptions, setRequestResourcesOptions] = useState([]);
  const user = useSelector((state) => state.auth?.user?.data);
  const [stages, setStages] = useState([
    {id: 0, name: messages.requests.stages.all_stages},
    {id: -1, name: messages.requests.stages.registered_With_no_Request},
    {id: 1, name: messages.requests.stages.new_requests},
    {id: 7, name: messages.requests.stages.rejected},
    {id: 2, name: messages.requests.stages.not_completed},
    {id: 3, name: messages.requests.stages.appointment_reservation},
    {id: 4, name: messages.requests.stages.interview},
    {id: 14, name: messages.requests.stages.no_interview},
    {id: 13, name: messages.requests.stages.obligation_sending},
    {id: 15, name: messages.requests.stages.obligation_no_sent},
    {id: 6, name: messages.requests.stages.payment},
    {id: 17, name: messages.requests.stages.not_paid},
    {id: 18, name: messages.requests.stages.sampling_reservation},
    {id: 9, name: messages.requests.stages.sampling},
    {id: 19, name: messages.requests.stages.not_sampling},
    {id: 8, name: messages.requests.stages.canceled},
  ])

  useEffect(() => {
    if (user) {
      if (parseInt(user.role_id) === 4 || parseInt(user.role_id) === 6 ) {
        setStages([ ...stages, 
            {id: 12, name: messages.requests.stages.completed},
        ])
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]) 

  const payload = { page: 1, sort: "created_at,desc" };

  const initialValues = {
    search: "",
    requestSource: 0, //ddl
    requestStatus: -1, 
  };

  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    requestSource: Yup.object().nullable(),
    requestStatus: Yup.object().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  useEffect(() => {
    if (!requestResources.length) dispatch(actions.requestSourcesRequest());
    return () => {
      dispatch(actions.requestSourcesReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //add all option
    if (requestResources.length)
      setRequestResourcesOptions([
        { id: 0, name: messages.requests.all_sources },
        ...requestResources,
      ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestResources]);

  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: e.target.value, requestSource: formik.values.requestSource, requestStatus: formik.values.requestStatus });
    dispatch(
      actions?.activeRequestsRequest({
        ...payload,
        ...formik.values,
        search: e.target.value,
      })
    );
  };
  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, requestSource: e.target.value, requestStatus: formik.values.requestStatus });
    dispatch(
      actions?.activeRequestsRequest({
        ...payload,
        ...formik.values,
        requestSource: e.target.value,
      })
    );
  };
  const searchWithStatus = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ search: formik.values.search, requestSource: formik.values.requestSource, requestStatus: e.target.value });
    dispatch(
      actions?.activeRequestsRequest({
        ...payload,
        ...formik.values,
        requestStatus: e.target.value,
      })
    );
  };
  
  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.requests.search_by_phone_or_name_or_id_placholder}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="requestSource"
              list={requestResourcesOptions}
              keyName="name"
              valueKeyName="id"
              value={formik.values.requestSource}
              handleChange={(e) => searchWithSelect(e, "requestSource")}
              error={formik.errors.requestSource}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="requestStatus"
              list={stages}
              keyName="name"
              valueKeyName="id"
              value={formik.values.requestStatus}
              handleChange={(e) => searchWithStatus(e, "requestStatus")}
              error={formik.errors.requestStatus}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
